import { Box } from "../Box/Box";
import { ButtonLink } from "../ButtonLink/ButtonLink";
import { Stack } from "../Stack/Stack";
import { Text } from "../Text/Text";

export function NoMenu() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      style={{ height: "85vh" }}
    >
      <Box maxWidth="small">
        <Stack space="4" align="center">
          <Box>
            <Text align="center">Could not load a menu for this location</Text>
          </Box>
          <ButtonLink primary href="/">
            Choose another location
          </ButtonLink>
        </Stack>
      </Box>
    </Box>
  );
}
